import { render, staticRenderFns } from "./assetClassification.vue?vue&type=template&id=2f8ef236&scoped=true"
import script from "./assetClassification.vue?vue&type=script&lang=js"
export * from "./assetClassification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ef236",
  null
  
)

export default component.exports